export const FEEDBACK_STATES = {
  UNSELECTED: 'UNSELECTED',
  HAPPY: 'HAPPY',
  NEUTRAL: 'NEUTRAL',
  UNHAPPY: 'UNHAPPY',
};

export const FEEDBACK_OPTIONS = [
  {
    value: FEEDBACK_STATES.HAPPY,
    emoji: '🙂',
    translationKey: 'eventFeedback.HappinessResponse.Happy',
    color: '#e8f1ee',
  },
  {
    value: FEEDBACK_STATES.NEUTRAL,
    emoji: '😐',
    translationKey: 'eventFeedback.HappinessResponse.Neutral',
    color: '#f1f5f9',
  },
  {
    value: FEEDBACK_STATES.UNHAPPY,
    emoji: '☹️',
    translationKey: 'eventFeedback.HappinessResponse.Unhappy',
    color: '#f9e9e9',
  },
];

export const IMPROVEMENT_OPTIONS = [
  {
    value: 'QUALITY',
    translationKey: 'eventFeedback.CanWeImprove.Topics.Quality',
  },
  {
    value: 'PUNCTUALITY',
    translationKey: 'eventFeedback.CanWeImprove.Topics.Punctuality',
  },
  {
    value: 'COMMUNICATION',
    translationKey: 'eventFeedback.CanWeImprove.Topics.Communication',
  },
  {
    value: 'PROFESSIONALISM',
    translationKey: 'eventFeedback.CanWeImprove.Topics.Professionalism',
  },
  {
    value: 'SCHEDULING',
    translationKey: 'eventFeedback.CanWeImprove.Topics.Scheduling',
  },
  {
    value: 'BILLING',
    translationKey: 'eventFeedback.CanWeImprove.Topics.Billing',
  },
  {
    value: 'OTHER',
    translationKey: 'eventFeedback.CanWeImprove.Topics.Other',
  },
];

export const FOLLOW_UP_STATES = {
  MORNING: 'MORNING',
  AFTERNOON: 'AFTERNOON',
  EVENING: 'EVENING',
  UNSELECTED: 'UNSELECTED',
};

export const FOLLOW_UP_OPTIONS = {
  UNSELECTED: 'eventFeedback.FollowUp.BestContactTime.Unselected',
  MORNING: 'eventFeedback.FollowUp.BestContactTime.Morning',
  AFTERNOON: 'eventFeedback.FollowUp.BestContactTime.Afternoon',
  EVENING: 'eventFeedback.FollowUp.BestContactTime.Evening',
};
